<template>
  <div class="bg-dirty-blue print-no-overlap rounded-lg flex flex-col md:flex-row items-start md:items-center mx-print-0 px-print-0 py-print-0 px-2 md:px-4 py-2 md:py-5">
    <div
      :class="{ color: iconColor }"
      class="h-10 min-w-10 md:h-14 md:min-w-14 mr-6 mb-2"
    >
      <slot name="icon">
        <fa
          :icon="icon"
          class="!size-full"
        />
      </slot>
    </div>

    <div>
      <h5
        v-if="title"
        class="mb-2"
      >
        <span
          v-if="titleKey"
          :data-i18n="titleKey"
        >{{ title }}</span>
        <span v-else>
          {{ title }}
        </span>
      </h5>
      <p
        v-if="text && !textTranslationKey"
        class="mb-0 font-secondary"
        :data-i18n="textKey"
        v-html="text"
      />
      <p
        v-else
        class="mb-0 font-secondary"
        :data-translation="textTranslationKey"
        v-html="text"
      />
      <slot />
    </div>
  </div>
</template>

<script>
import colors from '#tailwind-config/theme/colors'

export default defineNuxtComponent({
  props: {
    title: {
      type: String,
      default: '',
    },

    titleKey: {
      type: String,
      default: '',
    },

    text: {
      type: String,
      default: '',
    },

    textKey: {
      type: String,
      default: '',
    },

    textTranslationKey: {
      type: String,
      default: '',
    },

    icon: {
      type: [String, Object],
      default: null,
    },

    mobileTitle: {
      type: String,
      default: '',
    },

    mobileTitleKey: {
      type: String,
      default: '',
    },

    iconColor: {
      type: String,
      default: colors.blue.DEFAULT,
    },
  },

  computed: {
    hasIcon () {
      return this.icon !== undefined || this.$slots.icon
    },
  },
})
</script>
